import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext.js";
import { Layout } from "./components/Layout.js";
import { LoginPage } from "./pages/Login.js";
import { DashboardPage } from "./pages/Dashboard.js";
import { InfluencersPage } from "./pages/Influencers.js";
import { InfluencerDetailPage } from "./pages/InfluencerDetail.js";
import { IdeasPage } from "./pages/Ideas.js";
import { SessionsPage } from "./pages/Sessions.js";
import { SessionDetailPage } from "./pages/SessionDetail.js";
import { CatalogPage } from "./pages/Catalog.js";
import { ScenariosPage } from "./pages/Scenarios.js";
import { CalendarPage } from "./pages/Calendar.js";
import { ResultsPage } from "./pages/Results.js";
import { CostsPage } from "./pages/Costs.js";
import { ProvidersPage } from "./pages/Providers.js";
import { AutonomyPage } from "./pages/Autonomy.js";
import { IdentityVersionNewPage } from "./pages/IdentityVersionNew.js";

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { loggedIn, loading } = useAuth();
  if (loading) return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#888" }}>Cargando…</div>;
  if (!loggedIn) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { loggedIn, loading } = useAuth();
  if (loading) return null;
  if (loggedIn) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      <Route path="/influencers" element={<PrivateRoute><InfluencersPage /></PrivateRoute>} />
      <Route path="/influencers/:id" element={<PrivateRoute><InfluencerDetailPage /></PrivateRoute>} />
      <Route path="/influencers/:id/identity/new" element={<PrivateRoute><IdentityVersionNewPage /></PrivateRoute>} />
      <Route path="/ideas" element={<PrivateRoute><IdeasPage /></PrivateRoute>} />
      <Route path="/sessions" element={<PrivateRoute><SessionsPage /></PrivateRoute>} />
      <Route path="/sessions/:id" element={<PrivateRoute><SessionDetailPage /></PrivateRoute>} />
      <Route path="/catalog" element={<PrivateRoute><CatalogPage /></PrivateRoute>} />
      <Route path="/scenarios" element={<PrivateRoute><ScenariosPage /></PrivateRoute>} />
      <Route path="/calendar" element={<PrivateRoute><CalendarPage /></PrivateRoute>} />
      <Route path="/results" element={<PrivateRoute><ResultsPage /></PrivateRoute>} />
      <Route path="/costs" element={<PrivateRoute><CostsPage /></PrivateRoute>} />
      <Route path="/settings/providers" element={<PrivateRoute><ProvidersPage /></PrivateRoute>} />
      <Route path="/settings/autonomy" element={<PrivateRoute><AutonomyPage /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
